module.exports = __webpack_public_path__ + "img/logo.05aaec73.png";